import toLower from 'lodash/toLower';
import { actionTypes } from '../actions/my-path';
import { myPath as defaultState } from './default.json';
import config from '../config';
import { getCurriculumImage, getGenreHeaderImage } from '../utils/curriculum-utils';

export function getPathImage(response) {
  const responseImage = getCurriculumImage(response);
  if (responseImage !== '') {
    return responseImage;
  }
  const { instrument, style } = response || {};
  const headerImage = getGenreHeaderImage(instrument, style);
  return headerImage || null;
}

export function flattenLessons(playlists) {
  const flatLessons = [];
  if (playlists) {
    const lastPlaylistIndex = playlists.length - 1;
    playlists.forEach(({ courses, id: playlistID }, playlistIndex) => {
      const isLastPlaylist = playlistIndex === lastPlaylistIndex;
      const lastCourseIndex = courses.length - 1;
      courses.forEach(({ lessons, id: courseID, type: courseType }, courseIndex) => {
        const isLastCourseInPlaylist = courseIndex === lastCourseIndex;
        const lastLessonIndex = lessons.length - 1;
        lessons.forEach((lesson, lessonIndex) => {
          const isLastLessonInCourse = lastLessonIndex === lessonIndex;
          const isLastLessonInPlaylist = isLastLessonInCourse && isLastCourseInPlaylist;
          flatLessons.push({
            ...lesson,
            courseID,
            courseIndex,
            courseType,
            isLastLessonInPlaylist,
            isLastPlaylist,
            playlistIndex,
            playlistID,
          });
        });
      });
    });
  }
  return flatLessons;
}

const handlers = {
  [actionTypes.MY_PATH_SET_ERROR]: (state, action) => ({
    ...state,
    error: action.error,
    inProgress: false,
  }),
  [actionTypes.MY_PATH_SET_IN_PROGRESS]: state => ({
    ...state,
    error: null,
    inProgress: true,
  }),
  [actionTypes.MY_PATH_SET_SUCCESS]: (state, action) => ({
    ...state,
    color:
      config.genres[toLower(action.response.style || action.response.instrument)].color || 'blue',
    error: null,
    id: action.response.id,
    imageUrl: getPathImage(action.response),
    instrument: action.response.instrument,
    inProgress: false,
    flatLessons: flattenLessons(action.response.playlists),
    playlists: action.response.playlists,
    style: action.response.style,
    slug: action.response.slug,
  }),
  [actionTypes.MY_PATH_PROGRESS_ERROR]: (state, action) => ({
    ...state,
    error: action.error,
    inProgress: false,
  }),
  [actionTypes.MY_PATH_PROGRESS_IN_PROGRESS]: state => ({
    ...state,
    error: null,
    inProgress: true,
  }),
  [actionTypes.MY_PATH_PROGRESS_SUCCESS]: state => ({
    ...state,
    error: null,
    inProgress: false,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
